module.exports = __webpack_public_path__ + "static/media/MISC.1e44d79c.svg";